import React, { Component } from 'react';
import logo from '../../img/title.svg';
import alarm from '../../img/alarm.svg';
import shirt from '../../img/main-shirt.png';
import point from '../../img/point.svg';
import Big3Common from "../../js/Big3Common";
import { Link } from 'react-router-dom';

/* 개발담당:양유빈
 * 화면기능:풋터 공통 컴포넌트
 * 세부설명:헤더메인 페이지, 클로디 아이콘 이미지와 알림메세지 아이콘이 있는 디자인 
*/
export class HeaderMain extends Component {
    static displayName = HeaderMain.name;

    constructor(props) {
        super(props);
        this.state = {
            AlarmCount:0
        };
        Big3Common.Authentication(this);
    }
    //초기화
    async componentDidMount() {
        try {
            let data = await Big3Common.Get("api/MyPage/Notice/GetAllmMgtCount");
            if (data.codeName === Big3Common.ResultCode.Success) {
                this.setState({ AlarmCount: parseInt(data.objectData) }); 
            }
        }
        catch (e) {
            console.log("componentDidMount: ", e)
        }
    }
    
    render() {
        return (
            <header>
                <div className="main_title">
                    <Link className="main_logo" to="/">
                        <img src={logo} alt="logo" />
                    </Link>
                    <div className="main_alarm_group">
                        <Link to="/AIStudio/AIFittingMgr">
                            <img src={point} />
                        </Link>
                        <Link to="/AIStudio/Creator" className="item_hide">
                            <img src={shirt} />
                        </Link>
                        <Link to="/MyPage/Notice/Index">
                            <img src={alarm} alt="공지알람아이콘" />
                            {this.state.AlarmCount === 0 ? "" : <span><b>{this.state.AlarmCount}</b></span>}
                        </Link>
                    </div>
                </div>
            </header>
        );
    }
}
